import { Effect, Layer } from 'effect';
import { GavelConfig } from '../../../services/gavelConfig';
import { HttpService } from '../../../services/http';
import { GetOptions, GetSpaces } from './gavel/requests';
import { GetOptionsResolver, GetSpacesResolver } from './gavel/resolvers';
import { ConfigurationsService } from './service';
export const GavelConfigurationsService = Layer.effect(ConfigurationsService, Effect.gen(function* (_) {
    const http = yield* _(HttpService);
    const gavelConfig = yield* _(GavelConfig);
    const gavelUrl = gavelConfig.gavelUrl;
    const getSpacesResolver = GetSpacesResolver(http, gavelUrl);
    const getSpaces = (tenant) => Effect.request(GetSpaces({ tenant }), getSpacesResolver);
    const getOptionsResolver = GetOptionsResolver(http, gavelUrl);
    const getOptionsForSpace = (spaceId, tenant) => Effect.request(GetOptions({ spaceId, tenant }), getOptionsResolver);
    return { getSpaces, getOptionsForSpace };
}));
